import { Paper, Stack, Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AddButton,
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import formatDate from '../../../components/common/formatDate';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import TController from './create/TController';
import useGetData from '../helpers/useGetData';
import { getColumnLength } from '../helpers/utils';
import { GoSync } from 'react-icons/go';
import ModalCustom from '../../../components/common/Modal';
import AutoAddDaysValue from './AutoAddDaysValue';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
import useConfirm from '../../../components/common/useConfirm';
interface MyData {
  moduleData: any;
  handelSync: any;
  DialogSync: any;
  setModuleData: any;
  customer: any;
  isLoading: boolean;
  error?: string | null;
  customerforAuto: any;
  setCustomerforAuto: any;
}

const Create = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const annual_date = useQuery('annual_date');
  const created_date = useQuery('created_date');
  const [isAddModal, setIsAddModal] = useState(false);
  const [ChangeCustomer, confirmChangeCustomer] = useConfirm(
    'SAVE',
    'Save any changes before changing the Customer!'
  );

  const {
    moduleData,
    isLoading,
    error,
    customer,
    handelSync,
    setModuleData,
    DialogSync,
    customerforAuto,
    setCustomerforAuto,
  }: MyData = useGetData(annual_date, created_date);

  const onSubmit = async (isSubmitted: boolean) => {
    if (moduleData.length === 0) {
      alert('no data to save');
      return;
    }
    axios
      .post(`/api/salePlanningRoute`, moduleData)
      .then((res) => {
        window.alert('succesfully updated');
        // navigate(-1);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box>
      <Box>
        <ChildHeader text="Monthly Sales Report">
          <Box
            sx={{
              backgroundColor: '#f8f9fa',
              borderRadius: '5px',
              mr: 2,
              width: '16.6vw',
            }}
          >
            <AutocompleteMuiCustom
              label={''}
              id={'customer_name'}
              option_name={'customer_name'}
              value={customerforAuto}
              arrayofObj={customer}
              onChange={async (e, value) => {
                const ans = await confirmChangeCustomer();
                if (!ans) return;
                setCustomerforAuto(value);
              }}
            />
          </Box>
          {!isView && (
            <>
              <AddButton
                onClick={() => setIsAddModal(true)}
                sx={{
                  backgroundColor: '#c92a2a',
                  color: '#e7f5ff',
                }}
                label="Add Entry"
              />
              <CustomButton
                sx={{
                  backgroundColor: '#228be6',
                  color: '#e7f5ff',
                  mr: 2,
                }}
                icon={<GoSync />}
                size="large"
                onClick={() => handelSync()}
              >
                Sync Parts
              </CustomButton>
              <SubmitButton label="Save" onClick={() => onSubmit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
          isLoading,
        }}
        numberOfDay={getColumnLength(annual_date || '')}
      />
      <DialogSync isSubmitContent={false} />
      <ChangeCustomer isSubmitContent={false} />
      <ModalCustom
        title={'ADD NEW ENTRY'}
        openModal={isAddModal}
        closeModal={() => {
          setIsAddModal(false);
        }}
      >
        <AutoAddDaysValue
          moduleData={moduleData}
          numberOfDay={getColumnLength(annual_date || '')}
          setIsAddModal={setIsAddModal}
          setModuleData={setModuleData}
        />
      </ModalCustom>
    </Box>
  );
};

export default Create;
